import styled from 'styled-components'
import { Button } from '../button'

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	margin-top: 32px;
	padding: 24px;
	border-radius: 12px;
	background-color: ${props => props.theme.colors.brand.backgroundBlue};
`

export const ContactRow = styled.div`
	display: flex;
	justify-content: center;
	gap: 16px;
	width: 100%;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		flex-direction: column;
		align-items: stretch;
	}
`

export const ContactButton = styled(Button)`
	padding: 0 20px;
	min-width: 200px;

	.button-label {
		flex: 1;
		text-align: center;
	}

	&:focus {
		border: 1px solid ${props => props.theme.colors.brand.blueOmint};
		outline: none;
	}

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		min-width: 0;
		width: 100%;
		max-width: 100%;
	}
`
